import React from 'react'
import styles from "./styles.module.css";


function CustomSpinner() {
    return (
        <div className={`spinner-border ${styles.spinner}`} role="status">
            <span className="visually-hidden">{"loading"}</span>
        </div>
    )
}

export default CustomSpinner;